import { configureStore } from '@reduxjs/toolkit';
import ensemblesReducer from './ensemblesSlice';
import lessonsReducer from './lessonsSlice';
import sessionReducer from './sessionSlice';
import studentsReducer from './studentsSlice';
import uiReducer from './uiSlice';

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    ui: uiReducer,
    students: studentsReducer,
    ensembles: ensemblesReducer,
    lessons: lessonsReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
